import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserCircle,
  faClock,
  faUsers,
  faChartArea,
  faTasks,
  faRocket,
} from '@fortawesome/free-solid-svg-icons';

import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { NavLink } from 'react-router-dom';

/**
 * Agents list page under the home section.
 */
export const Agents = () => {
  return (
    <>
      <Helmet>
        <title>For Agents</title>
      </Helmet>
      <div className="intro">
        <Container className="max-w-xl pt-5 pb-5">
          <Row className="pt-5 mt-5">
            <Col lg={12}>
              <h1 className="text-center fw-bold mt-5">Built for agents, with agents</h1>
              <div className="header-divider" />
              <p className="text-center mt-4 mb-5 px-5">
                Industry specific CRM's give you the tools and resources you actually need.
              </p>
            </Col>
            <Col lg={12} className="text-center">
              <img src="/assets/home/agents/intro.png" className="w-50" />
            </Col>
          </Row>
        </Container>
      </div>

      <div className="bg-white">
        <Container className="max-w-xl pb-5">
          <Row className="pt-5 pb-5">
            <Col lg={12} className="pt-5">
              <h1 className="text-center fw-bold mt-5">Game Changer!</h1>
              <div className="header-divider" />
              <p className="text-center mt-4 mb-5 px-5">Fast track your business</p>
            </Col>
            <Col lg={6} className="pt-5">
              <h5 className="fw-bold">Online Enrollments</h5>
              <p>
                When you're ready to enroll a client or prospect, all the necessary data you've
                gathered in the CRM will populate the enrollment application at SunFire. All you
                need to do is pick the plan and get a signature!
              </p>
            </Col>
            <Col lg={6} className="pt-5">
              <h5 className="fw-bold">Plan Comparison</h5>
              <p>
                With a few clicks you can see how a clients drugs and pharmacies are priced on any
                plan in their service area. Every year you can re-run the comparison, no need to
                reenter drugs or pharmacies.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <Container className="max-w-xl pb-5">
        <Row className="pt-5 pb-5">
          <Col lg={12} className="pt-5">
            <h1 className="text-center fw-bold mt-5">World Class CRM</h1>
            <div className="header-divider" />
            <p className="text-center mt-4 mb-5 px-5">
              We strive to provide the absolute best user experience across every platform.
            </p>
          </Col>
          <Col lg={4} className="pt-5">
            <FontAwesomeIcon className="mt-5 text-primary h2 w-auto" icon={faUserCircle} />
            <h5 className="fw-bold">Client Profiles</h5>
            <p>
              Capture and store tons of data on clients or prospects like contact info, policy
              details, documents, providers, Rx, and more.
            </p>
          </Col>
          <Col lg={4} className="pt-5">
            <FontAwesomeIcon className="mt-5 text-primary h2 w-auto" icon={faClock} />
            <h5 className="fw-bold">Pending Business</h5>
            <p>
              Track all of your pending policies from one centralized location. Edit policy
              information and enrollment status on the fly.
            </p>
          </Col>
          <Col lg={4} className="pt-5">
            <FontAwesomeIcon className="mt-5 text-primary h2 w-auto" icon={faUsers} />
            <h5 className="fw-bold">Leads</h5>
            <p>
              Stay on top of prospects and leads, dictate notes, set appointments by integrating
              your calendar, send emails, set activities, etc.
            </p>
          </Col>
          <Col lg={4} className="pt-5">
            <FontAwesomeIcon className="mt-5 text-primary h2 w-auto" icon={faChartArea} />
            <h5 className="fw-bold">Analytics</h5>
            <p>
              Our renewal chain calculator lets you visualize your monthly renewal amounts over
              time. Also get important metrics about business performance.
            </p>
          </Col>
          <Col lg={4} className="pt-5">
            <FontAwesomeIcon className="mt-5 text-primary h2 w-auto" icon={faTasks} />
            <h5 className="fw-bold">Activities</h5>
            <p>
              Whether you're compiling of list of to do's for your business or clients, you can
              easily track and update important activities.
            </p>
          </Col>
          <Col lg={4} className="pt-5">
            <FontAwesomeIcon className="mt-5 text-primary h2 w-auto" icon={faRocket} />
            <h5 className="fw-bold">Dashboard</h5>
            <p>
              Get quick looks at production metrics, open leads, certification tracker, and
              important alerts.
            </p>
          </Col>
        </Row>
      </Container>
      <div className="bg-white">
        <Container className="max-w-xl py-5">
          <h1 className="text-center fw-bold mt-5">Specialized Tools</h1>
          <div className="header-divider" />
          <p className="text-center mt-4 mb-5 px-5">
            We are constantly developing tools to make your life easier.
          </p>

          <Row className="mt-5 mb-5">
            <Col lg={6} className="pt-5">
              <h5 className="fw-bold">Reporting & Marketing</h5>
              <p>
                Search and export your database on just about any data point. Isolate important
                groups and act on them, either with Blitz Mode or by drafting letter templates that
                auto populate with client data, then print with or without pre-made address labels.
                You can make an endless amount of correspondence templates and send them to some or
                all of your database.
              </p>
            </Col>
            <Col lg={6}>
              <img src="/assets/home/agents/reportingmarketing.png" className="w-100 shadow-m" />
            </Col>
          </Row>
          <Row className="mt-5 mb-5">
            <Col lg={6}>
              <img src="/assets/home/agents/renewals.png" className="w-100 shadow-m" />
            </Col>
            <Col lg={6} className="pt-5">
              <h5 className="fw-bold">Renewal visualization</h5>
              <p>
                Gain insight into your renewal chain over time and understand how pending business
                will influence your future income.
              </p>
            </Col>
          </Row>
          <Row className="mt-5 mb-5">
            <Col lg={6} className="pt-5">
              <h5 className="fw-bold">Aging in</h5>
              <p>
                Our aging in tool keeps you up to date on prospects that are nearing eligibility
                windows.
              </p>
            </Col>
            <Col lg={6}>
              <img src="/assets/home/agents/aging.png" className="w-100 shadow-m" />
            </Col>
          </Row>
          <Row className="mt-5 mb-5">
            <Col lg={6}>
              <img src="/assets/home/agents/activities.png" className="w-100 shadow-m" />
            </Col>
            <Col lg={6} className="pt-5">
              <h5 className="fw-bold">Activities</h5>
              <p>
                Set and keep track of important activities. You can pair them with a client so you
                always have a paper trail of the things you have done. Set deadlines and priorities.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="featured">
        <Container className="max-w-xl py-5">
          <h1 className="text-center fw-bold mt-5">And more cool stuff...</h1>

          <Row className="mt-5 mb-5">
            <Col lg={6} className="pt-5">
              <h5 className="fw-bold">Providers</h5>
              <p>
                Capture client or prospects providers. Indicate the provider importance and assign
                network tags. The system will auto-compile a handy provider table that shows who is
                in what network.
              </p>
            </Col>
            <Col lg={6}>
              <img src="/assets/home/agents/providers.png" className="w-100" />
            </Col>
          </Row>
          <Row className="mt-5 mb-5">
            <Col lg={6}>
              <img src="/assets/home/agents/policies.png" className="w-100" />
            </Col>
            <Col lg={6} className="pt-5">
              <h5 className="fw-bold text-white">Policies</h5>
              <p className="text-white">
                What makes MedicarePRO awesome for agents is we give you access to all medicare
                plans within an individuals service area so you will always know exactly what plan
                they have. Choose from MAPD, PDP, Med Sup, Ancillary, Life, and Individual Health.
              </p>
            </Col>
          </Row>
          <Row className="mt-5 mb-5">
            <Col lg={6} className="pt-5">
              <h5 className="fw-bold text-white">Rx</h5>
              <p className="text-white">
                A client profile wouldn't be complete until you gathered a list of drugs. Our drug
                finder is predictive so just start typing a few letters of the drug name and we will
                find the rest for you. You can also tag how each formulary prices the drug.
              </p>
            </Col>
            <Col lg={6}>
              <img src="/assets/home/agents/drugs.png" className="w-100" />
            </Col>
          </Row>
          <Row className="mt-5 mb-5">
            <Col lg={6}>
              <img src="/assets/home/agents/docs.png" className="w-100" />
            </Col>
            <Col lg={6} className="pt-5">
              <h5 className="fw-bold text-white">Store client docs</h5>
              <p className="text-white">
                Store client applications, SOA's, or whatever and easily access them from within
                their profile.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="max-w-xl pt-5 pb-5 text-center">
        <h1 className="text-center fw-bold mt-5">Give it a try</h1>
        <div className="header-divider" />
        <p className="text-center mt-4 mb-5 px-5 lead">
          We give you 30 days to try out MedicarePRO with unlimited access. No card info, no
          contracts.
        </p>
        <NavLink className="btn btn-primary" to="/home/sign-up" end>
          Start Free Trial
        </NavLink>
      </Container>
    </>
  );
};

export default Agents;
